export interface Organisation {
  id?: number;
  organisationUniqueKey?: string | null;
  name: string;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
}

export const getOrganisationInitialValue =
  (): Organisation => {
    return {
      id: 0,
      organisationUniqueKey: '',
      name: '',
      phone: '',
      address: '',
      city: '',
    };
  };

export enum OrganisationType {
  Facility = "Facility",
  FacilityGroup = "Facility Group",
}

export interface TicketFieldSetting {
  fieldId: number;
  name: string;
  type: string;
  label: string;
  sortable: boolean;
  showOnList: boolean;
  showOnForm: boolean;
  orderNo: number;
  isFilterField: boolean;
  filterFieldNum?: number;
  filedKey?: string | null;
  organisationId?: number | null;
}

export const getTicketFieldSettingInitialValue = (): TicketFieldSetting => {
  return {
    fieldId: 0,
    name: "",
    type: "",
    label: "",
    sortable: false,
    showOnList: false,
    showOnForm: false,
    orderNo: 0,
    isFilterField: false,
    filterFieldNum: 0,
    filedKey: "",
    organisationId: null,
  };
};
